import React from 'react';
import { Skeleton } from '@material-ui/lab';

export const LoadingSkeleton: React.FC = () => {
  return (
    <div className="page-container guide-page-content">
      <div className="guide-page-wrapper">
        <main className="guide-main-content">
          <div className="cost-centers-page">
            <section className="cost-centers-toolbar">
              {/* Header Skeleton */}
              <div className="cost-centers-overview-header">
                <div className="cost-centers-title-block">
                  <Skeleton variant="text" width={350} height={40} />
                </div>
                <div className="cost-centers-search-shell">
                  <Skeleton
                    variant="rect"
                    width="100%"
                    height={40}
                    style={{ borderRadius: '4px' }}
                  />
                </div>
              </div>

              {/* KPI Cards Skeleton */}
              <section className="cost-centers-overview-kpis">
                <div className="cost-centers-overview-kpis__grid">
                  {[...Array(7)].map((_, index) => (
                    <div key={index} className="cost-centers-overview-kpi-card">
                      <Skeleton variant="text" width="60%" height={20} />
                      <Skeleton
                        variant="text"
                        width="80%"
                        height={36}
                        style={{ marginTop: '8px' }}
                      />
                    </div>
                  ))}
                </div>
              </section>

              {/* Toolbar Skeleton */}
              <div className="cost-centers-toolbar-top">
                <div className="cost-centers-filters">
                  <div className="cost-centers-filter-field">
                    <div className="cost-centers-chip-group">
                      <Skeleton
                        variant="rect"
                        width={100}
                        height={32}
                        style={{ borderRadius: '16px', marginRight: '8px' }}
                      />
                      <Skeleton
                        variant="rect"
                        width={120}
                        height={32}
                        style={{ borderRadius: '16px', marginRight: '8px' }}
                      />
                      <Skeleton
                        variant="rect"
                        width={120}
                        height={32}
                        style={{ borderRadius: '16px' }}
                      />
                    </div>
                  </div>
                  <Skeleton
                    variant="rect"
                    width={150}
                    height={40}
                    style={{ borderRadius: '4px', marginLeft: '16px' }}
                  />
                </div>

                <div className="cost-centers-toolbar-actions">
                  <Skeleton
                    variant="rect"
                    width={80}
                    height={36}
                    style={{ borderRadius: '4px', marginRight: '8px' }}
                  />
                  <Skeleton
                    variant="rect"
                    width={100}
                    height={36}
                    style={{ borderRadius: '4px', marginRight: '8px' }}
                  />
                </div>
              </div>
            </section>

            {/* Grid Cards Skeleton */}
            <section className="cost-centers-results">
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                  gap: '16px',
                  marginTop: '24px',
                }}
              >
                {[...Array(8)].map((_, index) => (
                  <div
                    key={index}
                    style={{
                      borderRadius: '8px',
                      padding: '16px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '12px',
                      }}
                    >
                      <Skeleton variant="text" width="60%" height={24} />
                      <Skeleton
                        variant="rect"
                        width={60}
                        height={20}
                        style={{ borderRadius: '12px' }}
                      />
                    </div>
                    <Skeleton
                      variant="rect"
                      width={80}
                      height={20}
                      style={{ borderRadius: '12px', marginBottom: '16px' }}
                    />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '8px',
                      }}
                    >
                      <Skeleton variant="text" width="40%" height={20} />
                      <Skeleton variant="text" width="30%" height={20} />
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '8px',
                      }}
                    >
                      <Skeleton variant="text" width="45%" height={20} />
                      <Skeleton variant="text" width="25%" height={20} />
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '16px',
                      }}
                    >
                      <Skeleton variant="text" width="50%" height={20} />
                      <Skeleton variant="text" width="30%" height={20} />
                    </div>
                    <Skeleton
                      variant="rect"
                      width="100%"
                      height={8}
                      style={{ borderRadius: '4px' }}
                    />
                  </div>
                ))}
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};
